export default "<div class=\"container-fluid\">\r\n    <app-progress></app-progress>\r\n    <alert></alert>\r\n</div>\r\n<router-outlet></router-outlet>";